<template>
    <div>
        <el-table :data="compare" key="add" border style="width:97%">
            <el-table-column :label="title" prop="name"></el-table-column>
            <el-table-column label="内容" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "add_pay",
        props: {
            order_edit: {
                required: true
            }
        },
        data() {
            return {
                title:'添加项',
                compare: []
            }
        },
        created() {
            this.title = this.title+"（回款ID"+this.order_edit.content.id+")";
            this.setTitle();
        },
        methods:{
            setTitle(){
                let  actual_pay= {
                    name: '实际回款金额',
                    after: this.order_edit.content.actual_amount
                };
                let  actual_at= {
                    name: '实际回款日期',
                    after: (new Date(this.order_edit.content.actual_at*1000)).toLocaleDateString()
                };
                this.compare.push(actual_pay);
                this.compare.push(actual_at);

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/add_pay.vue